var map = {
	"./Approve.svg": "904c",
	"./Oval.svg": "7046",
	"./activate.svg": "5b38",
	"./any.svg": "ec3d",
	"./beds.svg": "f192",
	"./btc.svg": "3659",
	"./building.svg": "2a26",
	"./copy.svg": "87d1",
	"./days.svg": "4ff1",
	"./dot.svg": "2245",
	"./empty.svg": "0afe",
	"./entire_house.svg": "a8ea",
	"./eth.svg": "b4ad",
	"./eye.svg": "9be9",
	"./fora.svg": "c887",
	"./gov-sites.svg": "7ce1",
	"./home.svg": "e3e6",
	"./kabmin.svg": "0ae6",
	"./logo_ua.svg": "6214",
	"./man-edit-account.svg": "7b4c",
	"./min-integration.svg": "5715",
	"./nights.svg": "3a96",
	"./pencil.svg": "2d07",
	"./people.svg": "6b3b",
	"./red-heart-icon.svg": "43bb",
	"./room.svg": "4597",
	"./star.svg": "d8e7",
	"./telegram.svg": "7315",
	"./telegram_icon.svg": "d531",
	"./trash.svg": "5665",
	"./trident.svg": "8cb7",
	"./ukraine.svg": "29af",
	"./unactivate.svg": "acc7",
	"./usdt.svg": "45e4",
	"./victory.svg": "57cb",
	"./weeks.svg": "dab1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";